import { UIFetchStatus, UIFlightData } from "@flights/types";
import { isOfMetaOrigin } from "../../../../../utils/marketing-url-params";
import useBaggageInfo from "./Items/BaggageInfo/useBaggageInfo";
import useGeniusRewardsInfo from "./Items/GeniusRewardsInfo/useGeniusRewardsInfo";
import useFareRulesInfo from "./Items/FareRulesInfo/useFareRulesInfo";
import useExtraProductsInfo from "./Items/ExtraProductsInfo/useExtraProductsInfo";
import useExtraProductsInfo2 from "./Items/ExtraProductsInfo2/useExtraProductsInfo2";
import useTicketTypeInfo from "./Items/TicketTypeInfo/useTicketTypeInfo";
import useFareRulesStatusInfo from "./Items/FareRulesStatusInfo/useFareRulesStatusInfo";
import useAtolInfo from "./Items/AtolInfo/useAtolInfo";
import useOneWayCombinationInfo from "./Items/OneWayCombinationInfo/useOneWayCombinationInfo";
import useRyanairHungaryInfo from "./Items/RyanairHungaryInfo/useRyanairHungaryInfo";
import useUserAgent from "../../../../../hooks/useUserAgent";
import useUpgradeFareInfoDesktop from "./Items/UpgradeFareInfo/useUpgradeFareInfo.desktop";
import useUpgradeFareInfoMobile from "./Items/UpgradeFareInfo/useUpgradeFareInfo.mobile";
import { useTrackFareRulesAADiff } from "../../../../../utils/experiments/funnel/flights_web_fare_rules_aa_legs_diff";

type Props = {
  flight: UIFlightData;
  fetchStatus: UIFetchStatus;
};

const useFlightDetailsInfoController = ({ flight, fetchStatus }: Props) => {
  const { isMobile } = useUserAgent();

  const baggageInfo = useBaggageInfo(flight);
  const geniusRewardsInfo = useGeniusRewardsInfo(flight);
  const fareRulesInfo = useFareRulesInfo(flight);
  const extraProductsInfo = useExtraProductsInfo(flight);
  const extraProductsInfo2 = useExtraProductsInfo2(flight);
  const ticketTypeInfo = useTicketTypeInfo(flight);
  const fareRulesStatusInfo = useFareRulesStatusInfo(flight);
  const atolInfo = useAtolInfo(flight);
  const oneWayCombinationInfo = useOneWayCombinationInfo(flight);
  const ryanairHungaryInfo = useRyanairHungaryInfo(flight);
  const upgradeFareInfoMobile = useUpgradeFareInfoMobile(flight);
  const upgradeFareInfoDesktop = useUpgradeFareInfoDesktop(flight);

  useTrackFareRulesAADiff(flight);

  return {
    isLoading: fetchStatus === "loading" && !isOfMetaOrigin(),
    initialItems: [baggageInfo].filter((i) => !!i),
    items: [
      baggageInfo,
      geniusRewardsInfo,
      fareRulesInfo,
      isMobile ? upgradeFareInfoMobile : upgradeFareInfoDesktop,
      extraProductsInfo,
      extraProductsInfo2,
      ticketTypeInfo,
      fareRulesStatusInfo,
      atolInfo,
      oneWayCombinationInfo,
      ryanairHungaryInfo
    ].filter((i) => !!i)
  };
};

export default useFlightDetailsInfoController;
